import { clientV3SDK } from "@istari-frontend/api-client";
import { queryOptions } from "@tanstack/react-query";

import { NOTIFICATION_POLL_INTERVAL_MS } from "../notification-timing-policy";

export const notificationPollingQueryKeys = {
  list: () => ["notifications", "list"] as const,
};

export const notificationPollingQueryOptions = {
  list: () =>
    queryOptions({
      queryKey: notificationPollingQueryKeys.list(),
      queryFn: () => clientV3SDK.listNotifications(),
      refetchInterval: NOTIFICATION_POLL_INTERVAL_MS,
    }),
};
